/**
 * 箭头
 */

import React from 'react';
import { Icon, IconStyle } from './Icon';

interface Props {
    iconClassName?: string;
    style?: IconStyle;
}

export function RightArrow({ iconClassName, style }: Props) {
    return (
        <Icon style={style} iconClassName={`xt-icon-arrow-right ${iconClassName || ''}`}/>
    );
}
